<template>
  <b-card class="mb-0" no-body :style="'max-height: ' + sizecard">
    <template v-slot:header>
      <p class="m-0 p-0 normal-line-height">
        {{ titulo }}

        <small v-if="subtitle"> <br />Total de {{ titulo }} por data</small>
      </p>
    </template>
    <b-card-body class="p-0 area-chart">
      <loading-animation
        :active.sync="loading"
        :is-full-page="false"
        :opacity="1"
        color="#5895ff"
      />
      <area-chart
        :data="data"
        :labels="[titulo]"
        :xLabelFormat="dateFormat"
        class="area-chart-graph"
        grid="true"
        grid-text-weight="bold"
        id="area-chart"
        :line-colors="[color]"
        parseTime="false"
        resize="true"
        xkey="date"
        :ykeys="[tipo]"
        :style="'max-height:' + sizearea"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import Raphael from "raphael/raphael";
import { AreaChart } from "vue-morris";

global.Raphael = Raphael;

export default {
  name: "ClicksGraph",
  components: {
    AreaChart,
  },
  props: {
    data: Array,
    range: {
      type: String,
      default: "monthly",
    },
    loading: {
      type: Boolean,
      default: true,
    },
    subtitle: {
      type: Boolean,
      default: false,
    },
    titulo: {
      type: String,
      default: "Atendimentos",
    },
    tipo: {
      type: String,
      default: "atendimentos",
    },
    color: {
      type: String,
      default: "#63C763",
    },
    sizearea: {
      type: String,
      default: "180px",
    },
    sizecard: {
      type: String,
      default: "275px",
    },
  },
  methods: {
    dateFormat(d) {
      moment.locale(window.config.date_locale);
      return moment(d.label).format(
        this.range === "yearly"
          ? "MMMM"
          : this.range === "monthly"
          ? "DD, MMMM"
          : "DD, dddd"
      );
    },
  },
};
</script>
